import { isEqual } from 'lodash-es';
import useAntStaticComponent from 'common/hooks/useAntStaticComponent';
import { getPreviewTypeAndUrl } from 'common/utils/versionDetail';
import { useCommentContext } from '@/context/CommentContext';
import { useTaskEditorContext } from '@/context/TaskEditorContext';
import { Comment } from '@/types';

import {
  setIsCommentDrawerOpen,
  setNeedsRebuildAnnotation,
  setCurrentCommentIndex,
  selectCurrentCommentIndex,
} from '@/store/comment';
import { useAppDispatch } from './useAppDispatch';
import { useAppSelector } from './useAppSelector';

export function useRestoreCommentAndPlayer() {
  const dispatch = useAppDispatch();
  const { message: antdMessage } = useAntStaticComponent();

  const { setCurCommentId, isEditing, filteredCommentList } = useCommentContext();
  const curCommentIndex = useAppSelector(selectCurrentCommentIndex);

  const {
    getFileByComment,

    onPreviewFileChange,
    exportFile,
    fileList,
    isPlayList,
    setExportFile,
    setCurrentIndex,
    setCurrentFile,
    saveDefaultComment,
  } = useTaskEditorContext();

  const restoreComment = async (comment: Comment) => {
    console.log('%c [restoreComment]', 'font-size:14px; background:pink; color:#bf2c9f;');
    if (isEditing) {
      antdMessage.warning('请先保存当前编辑的反馈');
      return;
    }

    dispatch(setIsCommentDrawerOpen(false));

    await saveDefaultComment();

    const { file, index, fileId } = getFileByComment(comment);
    // console.log('restoreComment, file, index, fileId', comment, { file, index, fileId });
    if (file) {
      let { url, type } = getPreviewTypeAndUrl(file);
      //比较preview.url与exportFile是否相同，不相同则需要重新加载，文件列表模式不切换
      if (!isEqual(url, exportFile) && !isPlayList) {
        await onPreviewFileChange(fileList, index);
      }
      // setExportFile(url);
      setCurrentIndex(index);
      setCurrentFile(file);
    }
    //设置当前的的commentID
    setCurCommentId(comment.uniqueId);
    // 查找comment在filteredCommentList里的index
    const commentIndex = filteredCommentList.findIndex(item => item.uniqueId === comment.uniqueId);
    // // 设置当前的commentIndex
    dispatch(setCurrentCommentIndex(commentIndex));

    dispatch(setNeedsRebuildAnnotation(true));
  };
  const changeCommentIndex = (direction: 'increase' | 'decrease') => {
    const nextCommentIndex = direction === 'increase' ? curCommentIndex + 1 : curCommentIndex - 1;
    // 不能少于0，不能大于filteredCommentList.length - 1
    const index = Math.max(0, Math.min(filteredCommentList.length - 1, nextCommentIndex));
    const comment = filteredCommentList[index];
    if (comment) {
      // setCurCommentId(comment.uniqueId);
      // setCurCommentIndex(index);
      restoreComment(comment);
    } else {
      setCurCommentId(-1);
      dispatch(setCurrentCommentIndex(-1));
    }
  };
  return {
    restoreComment,
    changeCommentIndex,
  };
}
